$(function(){
    /*
     * Image must be loaded!!!!!!!!!!!!!!!!!
     * 
     */

    $.createImageColorReplace=function(path,options){
        function recolorImage(img){
            var c = document.createElement('canvas'),ctx=c.getContext("2d"),w = img.width,h = img.height,i,len,
            oldRed,oldGreen,oldBlue,newRed,newGreen,newBlue,tmp;
            tmp=settings.fromColor;
            tmp=tmp+"";
            oldRed=parseInt(tmp.substr(0,2),16);oldGreen=parseInt(tmp.substr(2,2),16);oldBlue=parseInt(tmp.substr(4,2),16);
            tmp=settings.newColor;
            tmp=tmp+"";
            newRed=parseInt(tmp.substr(0,2),16);newGreen=parseInt(tmp.substr(2,2),16);newBlue=parseInt(tmp.substr(4,2),16);
            if(settings.cropWidth){
                w=settings.cropWidth;
            }
            else{
                w-=settings.cropLeft;
            }
            if(settings.cropHeight){
               h=settings.cropHeight;
            }
            else{
                h-=settings.cropTop;
            }
            c.width = w;
            c.height = h;
            ctx.drawImage(img, settings.cropLeft, settings.cropTop, w, h,0,0,w,h);
            var imageData = ctx.getImageData(0, 0, w, h);
            len=imageData.data.length;
            for (i=0;i<len;i+=4){
                if(imageData.data[i]==oldRed &&
                   imageData.data[i+1]==oldGreen &&
                   imageData.data[i+2]==oldBlue
                ){
                    // change to your new rgb
                    imageData.data[i]=newRed;
                    imageData.data[i+1]=newGreen;
                    imageData.data[i+2]=newBlue;
                }
            }
            ctx.putImageData(imageData,0,0);
            return c.toDataURL('image/png');


        }
        
        
        
        
        
        if(typeof options==='object'){            
            var settings = $.extend( {
                fromColor: "000000",
                newColor: "ffffff",
                changeDimension: 1,
                cropLeft:0,
                cropTop:0,
                cropWidth:0,
                cropHeight:0
            }, options);
            settings.imageUrl=path;
            var image=new Image();
            image.src= settings.imageUrl;
            image.src= recolorImage(image);
//            debugArr(image);
            return image;

        }
        
    }; 
    
});